import React from 'react';
import { Box, Image, Link } from 'components';
import Icon from './components/icon';
import { styled } from 'themes';
import SVGInstagram from './assets/ic-instagram.svg';
import SVGFacebook from './assets/ic-facebook.svg';
import SVGTwitter from './assets/ic-twitter.svg';

const icons = [
  {
    src: SVGInstagram,
    url: 'https://www.instagram.com/yepstr/',
  },
  {
    src: SVGFacebook,
    url: 'https://www.facebook.com/yepstr',
  },
  {
    src: SVGTwitter,
    url: 'https://twitter.com/yepstr',
  },
];

const SocialIcons = props => {
  return (
    <Container {...props}>
      {icons.map((icon, i) => (
        <Link key={i} to={icon.url}>
          <Icon mr={20} src={icon.src} />
        </Link>
      ))}
    </Container>
  );
};

const Container = styled(Box)`
  display: flex;
`;

export default SocialIcons;
